import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBox from 'UIComponents/layout/UIBox';
import UIEEConnectedContactSalesButton from '../../button/UIEEConnectedContactSalesButton'; // @ts-expect-error dependency missing types

import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { getCorrectedUpgradeData } from '../../_core/utils/getCorrectedUpgradeData';
import { getApp, getBannerI18nSubTitleKey, getBannerI18nTitleKey, getProductI18nNameFromApiName, getScreen, getSource } from '../utils';
import DefaultBanner from './DefaultBanner';
export const buildBannerTitle = (featureTranslationKey, value, limit) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: getBannerI18nTitleKey('upgrades.limitPackBanner.header', featureTranslationKey),
    options: {
      value,
      limit
    }
  });
};
export const buildBannerSubtext = (apiName, featureTranslationKey) => {
  const translatedProductName = getProductI18nNameFromApiName('upgrades.products', apiName);
  return /*#__PURE__*/_jsx(UIBox, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: getBannerI18nSubTitleKey('upgrades.limitPackBanner.subtext', featureTranslationKey),
      options: {
        productName: translatedProductName
      }
    })
  });
};

const LimitPackBanner = ({
  upgradePoint,
  limit,
  value,
  displayThreshold,
  className,
  style,
  'data-test-id': dataTestId = 'limit-pack-banner',
  canViewNewSeats
}) => {
  const app = getApp();
  const screen = getScreen();
  const source = getSource(app, screen, upgradePoint.upgradeKey);
  const upgradeData = {
    app,
    screen,
    source,
    upgradeProduct: upgradePoint.upgradeProduct,
    upgradeProducts: upgradePoint.upgradeProducts,
    apiName: upgradePoint.apiName,
    apiNames: upgradePoint.apiNames,
    uniqueId: upgradePoint.upgradeKey,
    primaryColor: upgradePoint.primaryColor,
    team: upgradePoint.team,
    status: upgradePoint.status
  };
  const apiNameToUse = canViewNewSeats && upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct];
  const correctedUpgradeData = Object.assign({
    feature: upgradePoint.feature,
    pointType: upgradePoint.pointType,
    upgradeKey: upgradePoint.upgradeKey
  }, getCorrectedUpgradeData(upgradeData));

  const getUpgradeButton = apiName => {
    return /*#__PURE__*/_jsx(UIEEConnectedContactSalesButton, {
      apiName: apiName,
      upgradeData: correctedUpgradeData,
      use: "tertiary-light",
      isUpgradePoint: true
    });
  };

  if (displayThreshold && value < displayThreshold) {
    return null;
  }

  return /*#__PURE__*/_jsx(DefaultBanner, {
    titleText: buildBannerTitle(upgradePoint.featureTranslationKey, value, limit),
    className: className,
    dataTestId: dataTestId,
    subtext: buildBannerSubtext(apiNameToUse, upgradePoint.featureTranslationKey),
    style: style,
    button: getUpgradeButton(apiNameToUse)
  });
};

export default LimitPackBanner;